import ProceduresBadge from './ProceduresBadge';

export default ProceduresBadge;
